var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "rightColumn search__gridRightColumn hideOnMobile--block" },
    [
      _vm.response
        ? _c(
            "div",
            {
              staticClass: "searchSidebar",
              attrs: {
                id: "sidebar__main",
                tabindex: "0",
                role: "dialog",
                "aria-hidden": "true",
              },
            },
            [
              _c("SidebarFilter", {
                key: _vm.sidebarKey,
                on: {
                  "selected-accuracy": _vm.emittedAccuracyValue,
                  "selected-contentTypes": _vm.emittedContentTypeValue,
                  "selected-region": _vm.emittedRegionValue,
                  "selected-countries": _vm.emittedCountriesValue,
                  "selected-regionalBoost": _vm.emittedRegionalBoostValue,
                  "selected-interval": _vm.emittedIntervalValue,
                  "selected-archive": _vm.emittedArchiveValue,
                  "selected-sort": _vm.emittedSortValue,
                  "selected-category": _vm.emittedCategoryValue,
                  "selected-sub-category": _vm.emittedSubCategoryValue,
                  "selected-language": _vm.emittedLanguageValue,
                  "excluded-regions": _vm.emittedExcludedRegions,
                },
              }),
              _vm._v(" "),
              _vm.changed || _vm.checkIfFilterApplied()
                ? _c(
                    "div",
                    {
                      staticClass:
                        "facetedSearch__reset flex flex__justifyContent--center flex__alignItems--center",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "facetedSearch__resetText",
                          attrs: {
                            type: "button",
                            "data-gtm": "facetedSearch__resetAllTags",
                          },
                          on: { click: _vm.resetFilter },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.trans("RESET_ALL_FILTERS")) +
                              "\n                "
                          ),
                          _c(
                            "svg",
                            {
                              staticClass:
                                "searchIcon--16 searchIcon__left facetedSearch__resetIcon",
                              attrs: {
                                height: "16",
                                width: "16",
                                "aria-hidden": "true",
                              },
                            },
                            [
                              _c("use", {
                                attrs: { href: "#iconArrowClockwiseBold" },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("FacetedSearch"),
      _vm._v(" "),
      _c("RegionalBooster"),
      _vm._v(" "),
      _vm.topic.idcontent
        ? _c("div", { staticClass: "topfact__card searchCard" }, [
            _c("div", { staticClass: "topfact__top" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.trans("MOST_IMPORTANT_FACTS")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "topfact__headline" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.topic.keyword) + "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "topfact__content" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.topic.heading) + "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "topfact__button" }, [
              _c(
                "a",
                {
                  staticClass: "button button--primary",
                  attrs: {
                    href: _vm.path(_vm.topic),
                    "data-gtm": "search__topic--overview",
                  },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "left", 37, $event.key, [
                          "Left",
                          "ArrowLeft",
                        ])
                      )
                        return null
                      if ("button" in $event && $event.button !== 0) return null
                      return _vm.changeFocus.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.trans("GET_ON_OVERVIEW")) +
                      "\n            "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.topics.length > 0
        ? _c("div", { staticClass: "topic__title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.trans("OTHER_INTERESTING_TOPICS")) +
                "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "topic__container" },
        _vm._l(_vm.topics, function (item) {
          return _c(
            "a",
            {
              key: item.idcontent,
              staticClass: "topic__card",
              attrs: {
                "data-gtm": `search__topic--list${item.idcontent}`,
                href: _vm.path(item),
              },
              on: {
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "left", 37, $event.key, [
                      "Left",
                      "ArrowLeft",
                    ])
                  )
                    return null
                  if ("button" in $event && $event.button !== 0) return null
                  return _vm.changeFocus.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "topic__rect" }),
              _vm._v(" "),
              _c("div", { staticClass: "topic__content" }, [
                _vm._v(_vm._s(item.heading)),
              ]),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }